export default __webpack_public_path__ + "static/media/notification-bell.50618487.svg";